import { render } from "./CategoryUpdate.vue?vue&type=template&id=11c081e8"
import script from "./CategoryUpdate.vue?vue&type=script&lang=js"
export * from "./CategoryUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/vokaladezful-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__